import {
  AlertTriangle, ArrowLeft, BarChart2, Calendar, CheckCircle, Check,
  ChevronDown, ChevronLeft, ChevronRight, Clipboard, Clock, Copy, FileText,
  Inbox, LogIn, LogOut, Mail, MapPin, Moon, Pencil, RefreshCw, Search,
  Settings, Sun, Target, X, Zap, Info, AlertCircle,
} from 'lucide-react';

// Explicit map (rather than `import * as icons`) so unused Lucide icons get
// tree-shaken out of the production bundle — this app only needs a couple
// dozen of the library's 1000+ icons.
const ICONS = {
  'alert-triangle': AlertTriangle,
  'arrow-left': ArrowLeft,
  'bar-chart-2': BarChart2,
  calendar: Calendar,
  'check-circle': CheckCircle,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  clipboard: Clipboard,
  clock: Clock,
  copy: Copy,
  'file-text': FileText,
  inbox: Inbox,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  'map-pin': MapPin,
  moon: Moon,
  pencil: Pencil,
  'refresh-cw': RefreshCw,
  search: Search,
  settings: Settings,
  sun: Sun,
  target: Target,
  x: X,
  zap: Zap,
  info: Info,
  'alert-circle': AlertCircle,
};

/**
 * Icon — thin wrapper over lucide-react. Renders an inline, currentColor-
 * inheriting SVG so it tints with `color`. Falls back to an empty box if the
 * name isn't in the `ICONS` map — add new names there as they're used.
 */
export function Icon({ name, size = 20, strokeWidth = 2, color = 'currentColor', style, ...rest }) {
  const LucideIcon = ICONS[name];

  if (!LucideIcon) {
    return <span style={{ display: 'inline-block', width: size, height: size, ...style }} {...rest} />;
  }

  return (
    <LucideIcon
      width={size}
      height={size}
      color={color}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      style={{ display: 'inline-block', flex: 'none', verticalAlign: 'middle', ...style }}
      {...rest}
    />
  );
}
